import { c as _c } from "react/compiler-runtime";
import { ListBoxSelect } from '@systemeio/ui';
import { SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface';
import { useEffect, useState } from 'react';
import useUser from 'shared/hooks/use-user';
import { twJoin, twMerge } from 'tailwind-merge';
import { ChevronDownIcon } from '@systemeio/ui/icons';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
interface SubAccountSelectorProps {
  className?: string;
}
export const SubAccountSelector = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    dashboardUser,
    changeSubAccount,
    subAccountsData,
    avatarUrl
  } = useUser();
  const [selectedSubAccount, setSelectedSubAccount] = useState(null);
  let t1;
  let t2;
  if ($[0] !== dashboardUser) {
    t1 = () => {
      if (dashboardUser && hasSubAccounts(dashboardUser)) {
        const selectedSubAccount_0 = dashboardUser.subaccounts.find(subAccount => subAccount.user.id === dashboardUser.id) ?? dashboardUser.mainUser;
        setSelectedSubAccount(selectedSubAccount_0);
      }
    };
    t2 = [dashboardUser];
    $[0] = dashboardUser;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== avatarUrl || $[4] !== changeSubAccount || $[5] !== className || $[6] !== dashboardUser || $[7] !== selectedSubAccount?.displayName || $[8] !== selectedSubAccount?.user || $[9] !== subAccountsData) {
    t3 = hasSubAccounts(dashboardUser) ? <ListBoxSelect optionsClassName="z-50 cursor-pointer" buttonClassName="rounded-md" value={selectedSubAccount?.user.id} onChange={value => changeSubAccount(value)} data={subAccountsData()}>{open => <div className={twMerge("border-text-secondary/30 flex flex-row items-center justify-between break-all rounded-md border bg-transparent px-4 py-2 text-black", className)}><div className="flex items-center gap-3">{avatarUrl && <img className="h-[28px] w-[28px] min-w-[28px] overflow-hidden rounded-full object-cover" src={avatarUrl} alt={selectedSubAccount?.displayName} />}<span className="truncate text-wrap text-start">{selectedSubAccount?.displayName}</span></div><ChevronDownIcon className={twJoin("h-3 w-3 transition-transform", open && "rotate-180")} aria-hidden="true" /></div>}</ListBoxSelect> : null;
    $[3] = avatarUrl;
    $[4] = changeSubAccount;
    $[5] = className;
    $[6] = dashboardUser;
    $[7] = selectedSubAccount?.displayName;
    $[8] = selectedSubAccount?.user;
    $[9] = subAccountsData;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};